import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { MainGuard } from './main.guard';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [MainGuard],
    children: [
      {
        path: 'staff',
        children: [
          {
            path: 'list',
            loadChildren: () => import('../staff-list/staff-list.module').then((m) => m.StaffListModule),
          },
          {
            path: 'access',
            loadChildren: () => import('../staff-access/staff-access.module').then((m) => m.StaffAccessModule),
          },
          {
            path: 'logs',
            loadChildren: () => import('../staff-log/staff-log.module').then((m) => m.StaffLogModule),
          },
          {
            path: 'console',
            loadChildren: () =>
              import('../../staff-v2/pages/staff-console/staff-console.module').then((m) => m.StaffConsoleModule),
          },
        ],
      },
      {
        path: 'purchase',
        children: [
          // ── staff-v2 ──
          {
            path: 'list',
            loadChildren: () =>
              import('../../staff-v2/pages/purchase/list/purchase-list.module').then((m) => m.PurchaseListModule),
          },
          {
            path: 'detail',
            loadChildren: () =>
              import('../../staff-v2/pages/purchase/detail/purchase-detail.module').then((m) => m.PurchaseDetailModule),
          },
          {
            path: 'doc',
            loadChildren: () =>
              import('../purchase-docs-detail/purchase-docs-detail.module').then((m) => m.PurchaseDocsDetailModule),
          },
          { path: 'bank', loadChildren: () => import('../bank/bank.module').then((m) => m.BankModule) },
          {
            path: 'expired',
            loadChildren: () =>
              import('../purchase-expired-list/purchase-expired-list.module').then((m) => m.PurchaseExpiredListModule),
          },
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: '**', redirectTo: 'list' },
        ],
      },
      {
        path: 'user',
        children: [
          { path: 'list', loadChildren: () => import('../user-list/user-list.module').then((m) => m.UserListModule) },
          {
            path: 'detail',
            loadChildren: () => import('../user-detail/user-detail.module').then((m) => m.UserDetailModule),
          },
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: '**', redirectTo: 'list' },
        ],
      },
      {
        path: 'school',
        children: [
          {
            path: 'list',
            loadChildren: () => import('../school-list/school-list.module').then((m) => m.SchoolListModule),
          },
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: '**', redirectTo: 'list' },
        ],
      },
      {
        path: 'openclass',
        children: [
          {
            path: 'list',
            loadChildren: () => import('../openclass-list/openclass-list.module').then((m) => m.OpenclassListModule),
          },
          {
            path: 'detail',
            loadChildren: () =>
              import('../openclass-detail/openclass-detail.module').then((m) => m.OpenclassDetailModule),
          },
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: '**', redirectTo: 'list' },
        ],
      },
      {
        path: 'group/detail',
        loadChildren: () => import('../group-detail/group-detail.module').then((m) => m.GroupDetailModule),
      },
      {
        path: 'group/board',
        loadChildren: () => import('../group-board/group-board.module').then((m) => m.GroupBoardModule),
      },
      {
        path: 'product',
        children: [
          {
            path: 'list',
            loadChildren: () => import('../product-list/product-list.module').then((m) => m.ProductListModule),
          },
          {
            path: 'compose',
            loadChildren: () => import('../product-compose/product-compose.module').then((m) => m.ProductComposeModule),
          },
          {
            path: 'compose/:product_id',
            loadChildren: () => import('../product-compose/product-compose.module').then((m) => m.ProductComposeModule),
          },
          {
            path: 'detail/:product_id',
            loadChildren: () => import('../product-detail/product-detail.module').then((m) => m.ProductDetailModule),
          },
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: '**', redirectTo: 'list' },
        ],
      },
      {
        path: 'sms',
        children: [
          // ── staff-v2 ──
          {
            path: 'messages',
            loadChildren: () => import('../../staff-v2/pages/sms/list/sms-list.module').then((m) => m.SmsListModule),
          },
          {
            path: 'messages/:message_id',
            loadChildren: () =>
              import('../../staff-v2/pages/sms/details/sms-details.module').then((m) => m.SmsDetailsModule),
          },
          {
            path: 'senders',
            loadChildren: () =>
              import('../../staff-v2/pages/sms/senders/sms-senders.module').then((m) => m.SmsSendersModule),
          },
          {
            path: 'compose',
            loadChildren: () =>
              import('../../staff-v2/pages/sms/compose/sms-compose.module').then((m) => m.SmsComposeModule),
          },
          // ── legacy ──
          {
            path: 'senders-old',
            loadChildren: () => import('../sms/sms-sender/sms-sender.module').then((m) => m.SmsSenderModule),
          },
          {
            path: 'messages-old',
            loadChildren: () => import('../sms/sms-list/sms-list.module').then((m) => m.SmsListModule),
          },
          {
            path: 'messages-old/:message_id',
            loadChildren: () => import('../sms/sms-details/sms-details.module').then((m) => m.SmsDetailsModule),
          },
          { path: '', redirectTo: 'senders', pathMatch: 'full' },
          { path: '**', redirectTo: 'senders' },
        ],
      },
      {
        path: 'docs',
        children: [
          {
            path: 'compose',
            loadChildren: () => import('../docs-compose/docs-compose.module').then((m) => m.DocsComposeModule),
          },
          { path: 'list', loadChildren: () => import('../docs-list/docs-list.module').then((m) => m.DocsListModule) },
          { path: 'view', loadChildren: () => import('../docs-view/docs-view.module').then((m) => m.DocsViewModule) },
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: '**', redirectTo: 'list' },
        ],
      },
      { path: 'email', loadChildren: () => import('../email/email.module').then((m) => m.EmailModule) },
      { path: 'analysis', loadChildren: () => import('../analysis/analysis.module').then((m) => m.AnalysisModule) },
      { path: '', redirectTo: 'purchase/list', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [MainGuard],
})
export class MainRoutingModule {}
